/**
 * Re-export shared units service so web + native import the same implementation.
 * Real ADHA Basic Auth APIs live in `@/core/api/services/unitsService`.
 */
export {
  unitsService,
  UnitsService,
  type GetAvailableUnitsParams,
} from '@/core/api/services/unitsService';
